(function(){
  function init(root){
    root.querySelectorAll('[data-md-ba]').forEach(function(ba){
      if(ba.dataset.ready) return; ba.dataset.ready='1';
      var r=ba.querySelector('input[type=range]'); if(!r) return;
      var set=function(){ ba.style.setProperty('--x',r.value+'%'); };
      r.addEventListener('input',set); set();
    });
  }
  function all(){ document.querySelectorAll('.md-before-after').forEach(init); }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();
